import React from "react";
import Widget from "../../../components/Widget";

class Contact extends React.Component {
  render() {
    return (
      <Widget title="Contact" styleName="jr-card-profile-sm">
        {this.props.contactList.map((data, index) =>
          <div key={index} className="media align-items-center flex-nowrap jr-pro-contact-list">
            <div className="mr-3">
              <img src={require('../../../assets/images/icons/icon-' + data.icon + '.svg')} alt='' />
            </div>
            <div className="media-body">
              <span className="mb-1 text-grey jr-fs-sm">{data.title}</span>
              <p className="mb-0">{data.desc}</p>
            </div>
          </div>
        )}
      </Widget>
    )
  }
}
export default Contact;
